import "./secondaryMenu.css";
import { useState, useEffect } from "react";

const SecondaryScorecardMenu = ({ onTabHover, onTabLeave, hoveredTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scorecardHeaderHeightVal, setScorecardHeaderHeightVal] =
    useState(null);
  const [defaultFont, setDefaultFont] = useState(null);

  useEffect(() => {
    window.innerWidth <= 1024 ? setIsOpen(false) : setIsOpen(true);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 0;
      const scorecardHeader = document.querySelector(".scorecard-sub-header");
      const scorecardHeaderHeight = scorecardHeader
        ? scorecardHeader.offsetHeight
        : 0;
      setScorecardHeaderHeightVal(scorecardHeaderHeight + headerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
    if (window.innerWidth > 1024) {
      setIsOpen(true);
    }
  };

  const toggleAdvHamburger = () => {
    setIsOpen(!isOpen);
  };

  const clickAndCloseAdvHamburgerMenu = () => {
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
  };

  const scrollToCard = (cardId) => {
    const element = document.getElementById(cardId);
    if (!element) return;

    clickAndCloseAdvHamburgerMenu();

    const secondaryMenu = document.querySelector(".advanced-navbar");
    const hamburgerMenu = document.querySelector("#hamburger2");
    const p = document.querySelector("p");
    const fontSize = parseFloat(window.getComputedStyle(p).fontSize);
    setDefaultFont(fontSize);
    const secondaryMenuHeight = secondaryMenu ? secondaryMenu.offsetHeight : 0;
    const hamburgerMenuHeight = hamburgerMenu ? hamburgerMenu.offsetHeight : 0;

    const y =
      element.getBoundingClientRect().top +
      window.scrollY -
      scorecardHeaderHeightVal -
      secondaryMenuHeight -
      hamburgerMenuHeight -
      fontSize;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <>
      <div
        className="secondary-menu-wrapper"
        style={{ top: `${scorecardHeaderHeightVal}px` }}
      >
        <div
          id="hamburger2"
          onClick={toggleAdvHamburger}
          title="In page menu"
          aria-label="Click to expand the menu for cards"
        >
          <i className="fa-solid fa-bars" aria-hidden="true"></i> PAGE MENU{" "}
        </div>

        <div
          className="advanced-navbar"
          style={{
            display: isOpen ? "flex" : "none",
          }}
        >
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-preparation")}
            aria-label="Link to navigate to Pilot card"
            onMouseEnter={() => {
              onTabHover("scorecard-preparation");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "scorecard-preparation" && "var(--orange)",
            }}
          >
            Prepare
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-download")}
            aria-label="Link to navigate to Scorecard card"
            onMouseEnter={() => {
              onTabHover("scorecard-download");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color:
                hoveredTab === "scorecard-download" && "var(--cornflower-blue)",
            }}
          >
            Overview
          </div>

          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-assess")}
            aria-label="Link to navigate to Assess Wildfire Risk card card"
            onMouseEnter={() => {
              onTabHover("scorecard-assess");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "scorecard-assess" && "var(--green)",
            }}
          >
            Assess
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-collab")}
            aria-label="Link to navigate to Collaborate with Us card"
            onMouseEnter={() => {
              onTabHover("scorecard-collab");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "scorecard-collab" && "var(--orange)",
            }}
          >
            Collaborate
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-subscribe-long")}
            aria-label="Link to navigate to Subscribe card"
            onMouseEnter={() => {
              onTabHover("scorecard-subscribe-long");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color:
                hoveredTab === "scorecard-subscribe-long" &&
                "var(--cornflower-blue)",
            }}
          >
            Subscribe
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-feedback")}
            aria-label="Link to navigate to Share Your Feedback card"
            onMouseEnter={() => {
              onTabHover("scorecard-feedback");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "scorecard-feedback" && "var(--green)",
            }}
          >
            Feedback
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-contact")}
            aria-label="Link to navigate to Support us card"
            onMouseEnter={() => {
              onTabHover("scorecard-contact");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "scorecard-contact" && "var(--orange)",
            }}
          >
            Support
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("scorecard-contribute")}
            aria-label="Link to navigate to Contribute card"
            onMouseEnter={() => {
              onTabHover("scorecard-contribute");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color:
                hoveredTab === "scorecard-contribute" &&
                "var(--cornflower-blue)",
            }}
          >
            Contribute
          </div>
        </div>
      </div>
    </>
  );
};

export default SecondaryScorecardMenu;
